<template lang="pug">
  #list-deliveries
    b-button.float-right(v-if="user.role === 'admin' || user.role === 'viewer'" v-model="allPackagesReceived" :disabled="allPackagesReceived" @click="manualRecepction") Recepción Manual
    b-form-checkbox(
      v-model="allSelected"
      style="padding-left: 2.25rem; width: fit-content; font-weight: bold;"
      :indeterminate="indeterminate"
      @change="toggleAll"

    ) {{ allSelected ? 'Deseleccionar todos' : 'Seleccionar todos' }}
    div(ref="tableEl" style="overflow-x: auto; width: 100%;")
      b-table(:items="allPackages" :fields="packagesFields" v-if="packages")
        template(v-slot:cell(selected)="{ item }")
          b-form-checkbox(v-model="item.selected" @change="handleSelect(item)")
        template(#cell(id)="{item}")
          div {{ item.id }}
          div(v-if="item.isCanceled") (Cancelado)
        template(#cell(pickedUpByDriver)="{item, index}")
          div(:id="'tooltip-pickup-' + item.id")
            b-form-checkbox(v-model="item.pickedUpByDriver" @change='handlePickup(item, index)' :disabled="user.role!=='admin'")
          b-tooltip(v-if="item.pickedUpByDriverUser" :target="'tooltip-pickup-' + item.id" triggers="hover")
            |  {{ item.pickedUpByDriverUser && item.pickedUpByDriverUser.name }} {{ item.pickedUpByDriverUser && item.pickedUpByDriverUser.lastName }}
            br
            | {{ item.pickedUpByDriverAt }}
        template(#cell(receivedInWarehouse)="{item, index}")
          div(:id="'tooltip-received-in-warehouse-' + item.id")
            b-form-checkbox(v-model="item.receivedInWarehouse" @change='handleChange(item, index)' :disabled="!(user.role === 'admin' || user.role === 'viewer')")
          b-tooltip(v-if="item.receivedInWarehouseByUser" :target="'tooltip-received-in-warehouse-' + item.id" triggers="hover")
            | {{ item.receivedInWarehouseByUser && item.receivedInWarehouseByUser.name }} {{ item.receivedInWarehouseByUser && item.receivedInWarehouseByUser.lastName }}
            br
            | {{ item.receivedInWarehouseAt }}
        template(#cell(inTransit)="{item, index}")
          div(:id="'tooltip-in-transit-' + item.id")
            b-form-checkbox(v-model="item.inTransit" @change='handleInTransit(item, index)' :disabled="user.role!=='admin'")
          b-tooltip(v-if="item.inTransitByUser" :target="'tooltip-in-transit-' + item.id" triggers="hover")
            | {{ item.inTransitByUser && item.inTransitByUser.name }} {{ item.inTransitByUser && item.inTransitByUser.lastName }}
            br
            | Escaneado: {{item.inTransitScanMode}}
            br
            | {{ item.inTransitAt }}
        template(#cell(exchangeOrReturn)="{item, index}")
          div(:id="'tooltip-exchange-or-return-' + item.id")
            b-form-checkbox(v-model="item.exchangeOrReturn" @change='handleExchange(item, index)' :disabled="!(user.role==='admin' || user.role==='viewer')")
          b-tooltip(v-if="item.exchangeOrReturnByUser" :target="'tooltip-exchange-or-return-' + item.id" triggers="hover")
            | {{ item.exchangeOrReturnByUser && item.exchangeOrReturnByUser.name }} {{ item.exchangeOrReturnByUser && item.exchangeOrReturnByUser.lastName }}
            br
            | {{ item.exchangeOrReturnAt }}
        template(#cell(isAdditional)="{item}")
          div {{ item.isAdditional ? 'Si' : 'No' }}
        template(#cell(code)="{item}")
          div(style="text-wrap: nowrap") {{ item.code }}
        template(#cell(actions)="{item}")
          div(v-if="!item.isCanceled")
            //- b-btn.mb-2(@click="$refs.deliveryLabelTemplate.print(item)" block) Imprimir
            b-btn.mb-2(@click="$refs.allPackagesLabelTemplate.print([item])" block) Imprimir
            b-btn(v-if="user.role !== 'viewer'" @click="cancelPackage(item.realId)" variant="outline-danger" block) Cancelar
    .d-flex.justify-content-between
      div()
        p(v-if="user.role !== 'viewer'") Costo de Retiro: ${{ retirementPrice.toLocaleString('es-CL') }}
        p(v-if="volumeDiscount > 0 && user.role !== 'viewer'") Descuento por volumen: ${{ volumeDiscount.toLocaleString('es-CL') }}
      b-btn(@click="$refs.allPackagesLabelTemplate.print(packagesToPrint)" :disabled="!packagesToPrint.length") Imprimir etiquetas seleccionadas
        b-badge.ml-2(style="font-size: 0.9rem;" variant="info") {{ !packagesToPrint.length ? '' : packagesToPrint.length }}
    PrintAllPackagesLabel(ref="allPackagesLabelTemplate")
</template>
<script>
import { Printd } from 'printd'
import PrintAllPackagesLabel from '../withdrawal/printPackages/PrintAllPackagesLabel.vue'
import { mapGetters } from 'vuex'
import moment from 'moment-timezone'

export default {
  name: 'ListDeliveries',
  components: {
    PrintAllPackagesLabel
  },
  props: {
    retirementPrice: { type: Number },
    volumeDiscount: { type: Number },
    packages: {
      type: Array,
      required: true
    },
    storeName: {
      type: String,
      required: true
    },
    storeData: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      allPackages: [],
      allPackagesReceived: false,
      packagesToPrint: [],
      allSelected: false,
      indeterminate: false
    }
  },
  created () {
    this.handleSelectedPackages()
    this.checkPackagesToReceive()
  },
  methods: {
    handleKeydown (e) {
      if (e.key === 'ArrowLeft') {
        this.$refs.tableEl.scrollBy(-100, 0)
      } else if (e.key === 'ArrowRight') {
        this.$refs.tableEl.scrollBy(100, 0)
      }
    },
    handleSelectedPackages () {
      const allPackages = [...this.packagesItems].sort((a, b) => a.id - b.id)
      this.allPackages = allPackages
      const selected = this.packagesItems.filter((p) => p.selected)
      if (selected) {
        this.packagesToPrint = selected
        return selected
      } else {
        return selected
      }
    },
    handleSelect (item) {
      if (item.selected) {
        this.packagesToPrint.push(item)
      } else {
        this.allSelected = false
        this.indeterminate = true
        this.packagesToPrint = this.packagesToPrint.filter((p) => p.id !== item.id)
      }
    },
    toggleAll (checked) {
      if (checked) {
        this.allPackages = this.allPackages.map((p) => { return { ...p, selected: true } })
        this.packagesToPrint = this.allPackages
      } else {
        this.allPackages = this.allPackages.map((p) => { return { ...p, selected: false } })
        this.packagesToPrint = []
      }
      this.checkPackagesToReceive()
    },
    print () {
      console.log('print')
      const d = new Printd()
      d.print(document.getElementById('list-deliveries'), [])
    },
    async cancelPackage (id) {
      const ok = await this.$bvModal.msgBoxConfirm('¿Está seguro que desea cancelar el paquete?', {
        title: 'Cancelar paquete',
        okVariant: 'outline-danger',
        cancelVariant: 'outline-primary',
        okTitle: 'Aceptar',
        cancelTitle: 'Cancelar'
      })
      if (!ok) return
      try {
        await this.$store.dispatch('cancelPackage', { id })
        this.$root.$bvToast.toast('Paquete cancelado', {
          title: 'Éxito',
          variant: 'success',
          solid: true
        })
        this.$emit('update')
      } catch (error) {
        console.error(error)
        this.$root.$bvToast.toast('No se pudo cancelar el paquete', {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
      }
    },
    async manualRecepction () {
      const packages = this.allPackages
        .map((p, index) => ({ ...p, index }))
        .filter(p => p.receivedInWarehouse === false)
      await packages.map(async p => {
        const ok = await this.updateReceptionPackage(p.realId, { receivedInWarehouse: true }, p.index)

        if (ok) {
          p.receivedInWarehouse = true
          this.allPackages[p.index].receivedInWarehouse = true
        } else {
          console.log(ok)
        }
      })
      this.allPackagesReceived = true
    },
    async handleChange (myPackage, index) {
      const packageToReceive = this.allPackages.filter(p => p.receivedInWarehouse === false)
      if (packageToReceive.length) {
        this.allPackagesReceived = false
      }
      const id = myPackage.realId
      // const data = myPackage.receptionStatus ? { receptionStatus: 'received' } : { receptionStatus: 'not_received' }
      const data = { receivedInWarehouse: myPackage.receivedInWarehouse }
      await this.updateReceptionPackage(id, data, index)
      this.checkPackagesToReceive()
    },
    async updateReceptionPackage (id, data, index) {
      console.log('actualizando paquete....', id)
      try {
        const ok = await this.$store.dispatch('updateReceptionPackage', { id, data })
        // console.log(ok)

        if (ok.receivedInWarehouseAt) {
          // this.allPackages[index].receivedInWarehouse = true
          this.allPackages[index].receivedInWarehouseAt = moment(ok.receivedInWarehouseAt).format('DD-MM-YYYY HH:mm A')
          this.allPackages[index].receivedInWarehouseByUser = {
            name: ok.receivedInWarehouseByUser.name,
            lastName: ok.receivedInWarehouseByUser.lastName,
            email: ok.receivedInWarehouseByUser.email,
            id: ok.receivedInWarehouseByUser.id
          }
          return true
        }
      } catch (error) {
        console.error(error)
      }
    },
    checkPackagesToReceive () {
      const packagesToReceive = this.allPackages.filter(p => p.receivedInWarehouse === false)
      this.allPackagesReceived = !packagesToReceive.length
    },
    async handlePickup (myPackage, index) {
      const id = myPackage.realId
      const data = { pickedUpByDriver: myPackage.pickedUpByDriver }
      console.log('actualizando paquete....', id, data)
      try {
        const ok = await this.$store.dispatch('updatePickupPackage', { id, data })
        // console.log(ok)
        if (ok.pickedUpByDriverAt) {
          this.allPackages[index].pickedUpByDriverAt = moment(ok.pickedUpByDriverAt).format('DD-MM-YYYY HH:mm A')
          this.allPackages[index].pickedUpByDriverUser = {
            name: ok.pickedUpByDriverUser.name,
            lastName: ok.pickedUpByDriverUser.lastName,
            email: ok.pickedUpByDriverUser.email,
            id: ok.pickedUpByDriverUser.id
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    async handleInTransit (myPackage, index) {
      const id = myPackage.realId
      const data = { inTransit: myPackage.inTransit }
      console.log('actualizando paquete....', id, data)
      try {
        const ok = await this.$store.dispatch('updateInTransitPackage', { id, data })
        // console.log(ok)

        if (ok.inTransitAt) {
          this.allPackages[index].inTransitAt = moment(ok.inTransitAt).format('DD-MM-YYYY HH:mm A')
          this.allPackages[index].inTransitByUser = {
            name: ok.inTransitByUser.name,
            lastName: ok.inTransitByUser.lastName,
            email: ok.inTransitByUser.email,
            id: ok.inTransitByUser.id
          }
          this.allPackages[index].inTransitScanMode = 'manual'
        }
      } catch (error) {
        console.error(error)
      }
    },
    async handleExchange (myPackage, index) {
      const id = myPackage.realId
      const data = { exchangeOrReturn: myPackage.exchangeOrReturn }
      console.log('actualizando paquete....', id, data)
      try {
        const ok = await this.$store.dispatch('updateExchangeOrReturnPackage', { id, data })
        // console.log(ok)
        if (ok.exchangeOrReturnAt) {
          this.allPackages[index].exchangeOrReturnAt = moment(ok.exchangeOrReturnAt).format('DD-MM-YYYY HH:mm A')
          this.allPackages[index].exchangeOrReturnByUser = {
            name: ok.exchangeOrReturnByUser.name,
            lastName: ok.exchangeOrReturnByUser.lastName,
            email: ok.exchangeOrReturnByUser.email,
            id: ok.exchangeOrReturnByUser.id
          }
        }
      } catch (error) {
        console.error(error)
      }
    }
  },
  computed: {
    ...mapGetters(['user']),
    packagesFields () {
      let packagesFields = [
        { key: 'selected', label: 'Imprimir' },
        { key: 'code', label: 'Código' },
        { key: 'customerName', label: 'Nombre del destinatario' },
        { key: 'customerPhone', label: 'Teléfono de destinatario' },
        { key: 'customerAddress', label: 'Dirección de destino' },
        { key: 'commune', label: 'Comuna de destino' },
        { key: 'observations', label: 'Observaciones' },
        { key: 'customerEmail', label: 'Correo' },
        { key: 'tags', label: 'Tags' },
        { key: 'size', label: 'Tamaño del paquete' },
        { key: 'bundleQuantity', label: 'Cantidad de bultos' },
        { key: 'externalId', label: 'ID Externo' },
        { key: 'shippingCost', label: 'Costo de envío' },
        { key: 'pickedUpByDriver', label: 'Retirado por conductor' },
        { key: 'receivedInWarehouse', label: 'Recepcionado en Bodega' },
        { key: 'inTransit', label: 'En Tránsito' },
        { key: 'exchangeOrReturn', label: 'Cambio o devolución' },
        { key: 'actions', label: 'Acciones' }
      ]

      if (!(this.user.role === 'admin' || this.user.role === 'viewer')) {
        packagesFields = [{ key: 'id', label: 'N°' }].concat(packagesFields)
        packagesFields = packagesFields
          .filter(f =>
            f.key !== 'pickedUpByDriver' &
            f.key !== 'receivedInWarehouse' &
            f.key !== 'inTransit' &
            f.key !== 'exchangeOrReturn' &
            f.key !== 'isAdditional'
          )
      }

      if (this.user.role === 'viewer') {
        packagesFields = packagesFields.filter(f => f.key !== 'shippingCost' & f.key !== 'isAdditional')
      }

      return packagesFields
    },
    packagesItems () {
      return this.packages.map(p => {
        return {
          isCanceled: p.isCanceled,
          _rowVariant: p.isCanceled ? 'danger' : '',
          realId: p.id,
          id: p.id.toString().padStart(3, 0),
          customerName: p.customerName,
          customerPhone: p.customerPhone,
          commune: p.commune.name,
          customerEmail: p.customerEmail,
          size: p.size === 'small' ? 'PEQUEÑO' : 'MEDIANO',
          shippingCost: `$${p.shippingCost.toLocaleString('es-CL')}`,
          observations: p.observations,
          storeName: this.storeName,
          customerFullAddress: p.customerAddress,
          receptionStatus: p.receptionStatus === 'received' || false,
          receivedInWarehouse: p.receivedInWarehouse,
          receivedInWarehouseAt: p.receivedInWarehouseAt ? moment(p.receivedInWarehouseAt).format('DD-MM-YYYY HH:mm A') : null,
          receivedInWarehouseByUser: p.receivedInWarehouseByUser,
          isAdditional: p.isAdditional,
          code: p.code,
          qrCode: p.qrCode,
          selected: p.selected !== undefined ? p.selected : true,
          logoUrl: this.storeData.logoUrl || '',
          customizableFieldOne: this.storeData.customizableFieldOne || null,
          customizableFieldTwo: this.storeData.customizableFieldTwo || null,
          tags: p.tagsName || '',
          customerAddress: p.customerAddress,
          inTransit: p.inTransit,
          inTransitAt: p.inTransitAt ? moment(p.inTransitAt).format('DD-MM-YYYY HH:mm A') : null,
          inTransitByUser: p.inTransitByUser,
          exchangeOrReturn: p.exchangeOrReturn,
          exchangeOrReturnAt: p.exchangeOrReturnAt ? moment(p.exchangeOrReturnAt).format('DD-MM-YYYY HH:mm A') : null,
          exchangeOrReturnByUser: p.exchangeOrReturnByUser,
          pickedUpByDriver: p.pickedUpByDriver,
          pickedUpByDriverAt: p.pickedUpByDriverAt ? moment(p.pickedUpByDriverAt).format('DD-MM-YYYY HH:mm A') : null,
          pickedUpByDriverUser: p.pickedUpByDriverUser,
          withdrawalId: p.withdrawalId,
          bundleQuantity: p.bundleQuantity,
          inTransitScanMode: p.inTransitScanMode,
          externalId: p.externalId
        }
      })
    }
  },
  watch: {
    packagesItems: {
      handler (value) {
        const packagesToReceive = this.allPackages.filter(p => !p.receivedInWarehouse)
        this.allPackagesReceived = !packagesToReceive.length
      },
      deep: true
    },
    packagesToPrint (newValue, oldValue) {
      if (newValue.length === 0) {
        this.indeterminate = false
        this.allSelected = false
      } else if (newValue.length === this.packagesItems.length) {
        this.indeterminate = false
        this.allSelected = true
      } else {
        this.indeterminate = true
        this.allSelected = false
      }
    }
  },
  mounted () {
    window.addEventListener('keydown', this.handleKeydown)
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.handleKeydown)
  }
}
</script>
